import { config } from "core/config/app"

export const API_LIST_FAVORITE = `${config.apiPrefix}/${config.apiVersion}/recipe/my-favorite`
export const API_FAVORITE = `${config.apiPrefix}/${config.apiVersion}/recipe/favorite/:id`
